import React, { Children } from 'react';
import { motion } from 'framer-motion';
const sectionVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.25, 0.46, 0.45, 0.94],
      staggerChildren: 0.1
    }
  }
};
const childVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function PainSection() {
  return <section className="w-full px-5 py-20 md:py-28" style={{
    backgroundColor: 'var(--color-white)'
  }} data-id="element-137">
      <motion.div className="max-w-[720px] mx-auto" initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-80px'
    }} variants={sectionVariants} data-id="element-138">
        <motion.h2 variants={childVariants} className="text-3xl md:text-4xl mb-8" style={{
        color: 'var(--color-slate)',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-139">
          No estás "fallando".
        </motion.h2>

        <motion.p variants={childVariants} className="text-lg md:text-xl leading-relaxed mb-8" style={{
        color: 'var(--color-slate)',
        opacity: 0.85
      }} data-id="element-140">
          Estás intentando meter un plan de ejercicio de gente con vida estable…
          dentro de una vida que se interrumpe cada 7 minutos.
        </motion.p>

        <motion.p variants={childVariants} className="text-lg md:text-xl leading-relaxed mb-6" style={{
        color: 'var(--color-slate)',
        opacity: 0.85
      }} data-id="element-141">
          Si eres mamá, ya conoces este guion:
        </motion.p>

        {/* The shame cycle */}
        <motion.div variants={childVariants} className="relative pl-8 md:pl-10 mb-10 space-y-4" data-id="element-142">
          {/* Vertical line */}
          <div className="absolute left-3 md:left-4 top-2 bottom-2 w-px" style={{
          backgroundColor: 'var(--color-sage)',
          opacity: 0.4
        }} data-id="element-143" />

          <div className="relative" data-id="element-144">
            <div className="absolute -left-5 md:-left-6 top-2 w-2.5 h-2.5 rounded-full" style={{
            backgroundColor: 'var(--color-sage)'
          }} data-id="element-145" />
            <p className="text-base md:text-lg leading-relaxed" style={{
            color: 'var(--color-slate)'
          }} data-id="element-146">
              Te propones entrenar
            </p>
          </div>

          <div className="relative" data-id="element-147">
            <div className="absolute -left-5 md:-left-6 top-2 w-2.5 h-2.5 rounded-full" style={{
            backgroundColor: 'var(--color-sage)'
          }} data-id="element-148" />
            <p className="text-base md:text-lg leading-relaxed" style={{
            color: 'var(--color-slate)'
          }} data-id="element-149">
              Te cambia el día
            </p>
          </div>

          <div className="relative" data-id="element-150">
            <div className="absolute -left-5 md:-left-6 top-2 w-2.5 h-2.5 rounded-full" style={{
            backgroundColor: 'var(--color-sage)'
          }} data-id="element-151" />
            <p className="text-base md:text-lg leading-relaxed" style={{
            color: 'var(--color-slate)'
          }} data-id="element-152">
              Llega el cansancio real (no el "ay qué flojera")
            </p>
          </div>

          <div className="relative" data-id="element-153">
            <div className="absolute -left-5 md:-left-6 top-2 w-2.5 h-2.5 rounded-full" style={{
            backgroundColor: 'var(--color-sage)'
          }} data-id="element-154" />
            <p className="text-base md:text-lg leading-relaxed" style={{
            color: 'var(--color-slate)'
          }} data-id="element-155">
              Fallas un día
            </p>
          </div>

          <div className="relative" data-id="element-156">
            <div className="absolute -left-5 md:-left-6 top-2 w-2.5 h-2.5 rounded-full" style={{
            backgroundColor: 'var(--color-tan)'
          }} data-id="element-157" />
            <p className="text-base md:text-lg leading-relaxed font-semibold" style={{
            color: 'var(--color-slate)'
          }} data-id="element-158">
              Y tu cabeza traduce eso como: <em data-id="element-159">"ya lo arruiné"</em>
            </p>
          </div>
        </motion.div>

        <motion.p variants={childVariants} className="text-lg md:text-xl leading-relaxed mb-4" style={{
        color: 'var(--color-slate)',
        opacity: 0.85
      }} data-id="element-160">
          Entonces vuelves al lunes.
        </motion.p>

        <motion.p variants={childVariants} className="text-lg md:text-xl leading-relaxed mb-10" style={{
        color: 'var(--color-slate)',
        opacity: 0.85
      }} data-id="element-161">
          Y el lunes vuelve a pasar lo mismo.
        </motion.p>

        {/* Separator */}
        <motion.div variants={childVariants} className="w-16 h-px mx-auto mb-10" style={{
        backgroundColor: 'var(--color-tan)'
      }} data-id="element-162" />

        <motion.p variants={childVariants} className="text-lg md:text-xl leading-relaxed mb-6" style={{
        color: 'var(--color-slate)',
        opacity: 0.85
      }} data-id="element-163">
          La parte cruel es que mientras tanto, tu cuerpo se siente:
        </motion.p>

        <motion.ul variants={childVariants} className="space-y-3 mb-10 pl-1" data-id="element-164">
          <li className="flex items-start gap-3 text-base md:text-lg" style={{
          color: 'var(--color-slate)'
        }} data-id="element-165">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
            backgroundColor: 'var(--color-tan)'
          }} data-id="element-166" />
            más flojo
          </li>
          <li className="flex items-start gap-3 text-base md:text-lg" style={{
          color: 'var(--color-slate)'
        }} data-id="element-167">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
            backgroundColor: 'var(--color-tan)'
          }} data-id="element-168" />
            menos firme
          </li>
          <li className="flex items-start gap-3 text-base md:text-lg" style={{
          color: 'var(--color-slate)'
        }} data-id="element-169">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
            backgroundColor: 'var(--color-tan)'
          }} data-id="element-170" />
            con menos energía
          </li>
          <li className="flex items-start gap-3 text-base md:text-lg" style={{
          color: 'var(--color-slate)'
        }} data-id="element-171">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
            backgroundColor: 'var(--color-tan)'
          }} data-id="element-172" />
            y con más culpa encima
          </li>
        </motion.ul>

        <motion.p variants={childVariants} className="text-lg md:text-xl leading-relaxed mb-3" style={{
        color: 'var(--color-slate)',
        opacity: 0.85
      }} data-id="element-173">
          No porque "no puedas".
        </motion.p>

        <motion.p variants={childVariants} className="text-xl md:text-2xl leading-relaxed font-semibold" style={{
        color: 'var(--color-slate)',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-174">
          Sino porque el plan que intentas usar{' '}
          <span style={{
          color: 'var(--color-tan)'
        }} data-id="element-175">
            no fue diseñado para tu realidad.
          </span>
        </motion.p>
      </motion.div>
    </section>;
}